module.exports = __webpack_public_path__ + "img/img1.030faf36.jpg";